export enum SurveyOpinionResposnseStatusEnum {
  Submitted = "Submitted",
  Rejected = "Rejected",
  Approved = "Approved"
}
